var _rect, _rect2, _path, _path2, _ellipse, _rect3, _rect4, _path3, _path4, _ellipse2, _rect5, _rect6, _path5, _ellipse3, _rect7, _rect8, _ellipse4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSplash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 144,
    viewBox: "0 0 137 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 106.603,
    width: 16.7642,
    height: 41.2423,
    rx: 8.38208,
    transform: "rotate(-43.174 0 106.603)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.3046,
    height: 55.5059,
    rx: 8.6523,
    transform: "matrix(-0.729279 -0.684216 -0.684216 0.729279 67.0576 96.3171)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0445 2.61983C96.7299 -1.53849 101.473 -0.343432 103.338 3.38663C103.776 4.26296 105.178 5.48983 107.281 3.38663C109.034 1.19584 116.483 -3.18584 125.684 8.64465L125.603 8.51383C131.311 15.9321 134.391 26.7911 135.632 42.8799C136.696 56.6992 136.473 58.4553 133.159 62.3522C128.45 67.8884 123.489 67.7837 118.604 62.0401L114.697 57.4464L111.751 62.0401C108.143 67.6648 101.557 67.9931 97.1144 62.7691C93.8756 58.9608 93.7865 58.9608 90.8543 62.7691C86.939 67.8562 80.7321 67.6729 76.1934 62.3361C72.9255 58.4936 72.6463 56.5422 73.5489 43.8788C74.8043 26.2654 81.6039 9.19162 89.95 2.69281C89.9814 2.66838 90.0129 2.64406 90.0445 2.61983Z",
    fill: "#FF6C3E",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0613 2.61983C25.7467 -1.53849 30.4894 -0.343432 32.3545 3.38663C32.7926 4.26296 34.1948 5.48983 36.298 3.38663C38.0506 1.19584 45.4994 -3.18584 54.7009 8.64465L54.62 8.51383C60.328 15.9321 63.408 26.7911 64.6488 42.8799C65.7124 56.6992 65.4898 58.4553 62.1756 62.3522C57.4673 67.8884 52.5055 67.7837 47.6208 62.0401L43.7141 57.4464L40.7682 62.0401C37.1595 67.6648 30.574 67.9931 26.1312 62.7691C22.8924 58.9608 22.8034 58.9608 19.8712 62.7691C15.9559 67.8562 9.74893 67.6729 5.2102 62.3361C1.94231 58.4936 1.66313 56.5422 2.56574 43.8788C3.82118 26.2654 10.6207 9.19162 18.9669 2.69281C18.9982 2.66838 19.0297 2.64406 19.0613 2.61983Z",
    fill: "#FFD36A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.9395,
    cy: 36.4807,
    rx: 19.5,
    ry: 19,
    fill: "url(#paint0_radial_448_155)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5676,
    y: 22.7795,
    width: 3.65466,
    height: 9.13665,
    rx: 1.82733,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3589,
    y: 22.7795,
    width: 3.65466,
    height: 9.13665,
    rx: 1.82733,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3949 37.3982C28.4146 38.7771 33.8004 40.7077 39.1862 37.3982",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0445 79.6179C96.7299 75.4596 101.473 76.6546 103.338 80.3847C103.776 81.261 105.178 82.4879 107.281 80.3847C109.034 78.1939 116.483 73.8122 125.684 85.6427L125.603 85.5119C131.311 92.9301 134.391 103.789 135.632 119.878C136.696 133.697 136.473 135.453 133.159 139.35C128.45 144.886 123.489 144.782 118.604 139.038L114.697 134.444L111.751 139.038C108.143 144.663 101.557 144.991 97.1144 139.767C93.8756 135.959 93.7865 135.959 90.8543 139.767C86.939 144.854 80.7321 144.671 76.1934 139.334C72.9255 135.492 72.6463 133.54 73.5489 120.877C74.8043 103.263 81.6039 86.1897 89.95 79.6909C89.9814 79.6664 90.0129 79.6421 90.0445 79.6179Z",
    fill: "#3A4CD9",
    fillOpacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.939,
    cy: 113.48,
    rx: 19.5,
    ry: 19,
    fill: "url(#paint1_radial_448_155)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8336,
    y: 99.5273,
    width: 3.65466,
    height: 9.13665,
    rx: 1.82733,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 108.625,
    y: 99.5273,
    width: 3.65466,
    height: 9.13665,
    rx: 1.82733,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7113 114.947C94.9082 115.021 95.0976 115.123 95.2753 115.253C95.8994 115.724 96.6128 115.973 97.3397 115.973C98.0666 115.973 98.78 115.724 99.4041 115.253C99.7974 114.972 100.241 114.824 100.693 114.824C101.145 114.824 101.589 114.972 101.982 115.253C102.614 115.71 103.329 115.951 104.057 115.951C104.784 115.951 105.499 115.71 106.131 115.253C106.524 114.972 106.968 114.824 107.42 114.824C107.872 114.824 108.316 114.972 108.709 115.253C109.347 115.715 110.069 115.96 110.804 115.967C111.514 115.965 112.21 115.718 112.818 115.253C112.996 115.123 113.261 114.905 113.458 114.832C113.714 114.738 113.855 114.633 113.983 114.337C114.111 114.041 114.142 113.692 114.067 113.367C113.992 113.043 113.818 112.77 113.584 112.607C113.35 112.445 113.074 112.406 112.818 112.501C112.465 112.639 112.127 112.832 111.811 113.074C111.49 113.312 111.125 113.437 110.754 113.437C110.382 113.437 110.017 113.312 109.696 113.074C108.998 112.579 108.211 112.319 107.41 112.319C106.61 112.319 105.822 112.579 105.124 113.074C104.8 113.313 104.432 113.438 104.057 113.438C103.682 113.438 103.313 113.313 102.989 113.074C102.291 112.579 101.504 112.319 100.703 112.319C99.9026 112.319 99.1155 112.579 98.4172 113.074C98.0964 113.312 97.7315 113.437 97.3598 113.437C96.9882 113.437 96.6233 113.312 96.3024 113.074C95.9867 112.832 95.6485 112.639 95.2954 112.501C95.039 112.406 94.7634 112.445 94.5292 112.607C94.295 112.77 94.1214 113.043 94.0467 113.367C93.9719 113.692 94.002 114.041 94.1304 114.337C94.2589 114.633 94.4751 114.853 94.7315 114.947H94.7113Z",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.5,
    cy: 36,
    rx: 19.5,
    ry: 19,
    fill: "url(#paint2_radial_448_155)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8337,
    y: 22.7795,
    width: 3.65466,
    height: 9.13665,
    rx: 1.82733,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108.625,
    y: 22.7795,
    width: 3.65466,
    height: 9.13665,
    rx: 1.82733,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.057,
    cy: 37.3982,
    rx: 2.741,
    ry: 3.65466,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_448_155",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9395 36.4807) rotate(90) scale(19 19.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2FFB1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#DFF3BE",
    stopOpacity: 0.545833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_448_155",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.939 113.48) rotate(90) scale(19 19.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_448_155",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.5 36) rotate(90) scale(19 19.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB1D2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSplash);
export default __webpack_public_path__ + "static/media/logo_splash.ee65b22354d73617890b11ebc8aecc70.svg";
export { ForwardRef as ReactComponent };